import { render } from "./TextLang.vue?vue&type=template&id=89cc2146"
import script from "./TextLang.vue?vue&type=script&lang=js"
export * from "./TextLang.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__